import { useMemo } from 'react';
import '/assets/styles/sections/home-lottery-info.scss';

// Partials
import Btn from '/views/partials/btn';
import LotteryBranchCounts from '/views/partials/lottery-branch-counts';
import LotteryHeadline from '/views/partials/lottery-headline';

// Context
import { useAuth } from '@wearetla/tla-essentials-tools/utilities/auth';
import { useLottery } from '/utilities/lottery';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useTranslation } from '/utilities/i18n';

const HomeLotteryInfo = () => {
	const { loggedIn, initialized: authInitialized } = useAuth();
	const { enabled, initialized, branches, userLotteryStatus } = useLottery();
	const { openModal } = useModals();
	const { t } = useTranslation();

	// Bilgileri tamamlanmış kullanıcı QR okutur, tamamlanmamış kullanıcı önce forma gider.
	const ctaProps = useMemo(() => {
		if (userLotteryStatus) {
			return {
				icon: 'qr',
				onClick: () => {
					openModal('lotteryQr');
				},
			};
		}

		return {
			tag: 'link',
			href: 'account.lottery',
		};
	}, [userLotteryStatus, openModal]);

	// Oturum durumu belli olana kadar sayaçlar yerine placeholder gösterilir.
	const loading = !authInitialized || (loggedIn && !initialized);

	if (!enabled) {
		return null;
	}

	return (
		<section className="section home-lottery-info">
			<div className="wrapper">
				<LotteryHeadline className="lottery-info-head" />

				<div className="lottery-info-card">
					{authInitialized && !loggedIn ? (
						<>
							<strong className="lottery-info-guesttitle">
								{t('Çekilişe katılmak için giriş yap')}
							</strong>
							<p className="lottery-info-guestmessage">
								{t(
									'Giriş yap, kampanyaya katıl; her siparişin iPhone 17 ve AirPods kazanma şansına dönüşsün.'
								)}
							</p>

							<Btn
								className="lottery-info-cta yellow-light block"
								onClick={() => {
									openModal('auth');
								}}
							>
								{t('Giriş Yap / Üye Ol')}
							</Btn>
						</>
					) : (
						<>
							<LotteryBranchCounts branches={branches} loading={loading} />

							<Btn {...ctaProps} className="lottery-info-cta yellow-light block">
								{userLotteryStatus ? t('Sipariş Eşleştir') : t('Kampanyaya Katıl')}
							</Btn>

							{userLotteryStatus && (
								<Btn
									tag="link"
									href="account.lottery"
									className="lottery-info-detailslink text-small nude hyperlink"
								>
									{t('Kampanya Detayları')}
								</Btn>
							)}
						</>
					)}

					<div className="lottery-info-disclaimer">
						{t(
							'Kampanya Milli Piyango İdaresi Genel Müdürlüğü’nün 13.10.2026 tarih ve E-40453693-255.01.02-98673 sayılı izni ile düzenlenmektedir.'
						)}
					</div>
				</div>
			</div>
		</section>
	);
};

export default HomeLotteryInfo;
